import heroMoonBackground from "../assets/images/hero-moon-background-no-line.png";
import heroLunarGround from "../assets/images/hero-lunar-ground.png";
import { Link } from "react-router-dom";

const heroImage = `${process.env.PUBLIC_URL}/images/hero-astronaut.png`;

function HeroScene() {
  return (
    <div className="hero-scene" aria-hidden="true">
      <div
        className="hero-moon-background"
        style={{ backgroundImage: `url(${heroMoonBackground})` }}
      />
      <div className="hero-soft-effects" />
      <img
        className="hero-lunar-ground"
        src={heroLunarGround}
        alt=""
        draggable="false"
      />
    </div>
  );
}

function HeroVisual() {
  return (
    <div className="hero-visual">
      <div className="hero-visual-effects" aria-hidden="true">
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>
      <img src={heroImage} alt="Astronaut" />
    </div>
  );
}

function Hero() {
  return (
    <section className="hero-section" id="section0">
      <HeroScene />

      <div className="container2 hero-desktop">
        <div className="cloud-back">
          <div className="hero-row">
            <div className="hero-copy">
              <h1>APPIVOROUS</h1>
              <h2>Built for What's Next.</h2>
              <p>We make technology feel inevitable.</p>
              <p>An insatiable drive to create and</p>
              <p>advance digital technology.</p>
              <Link className="hero-cta" to="/services">
                Explore Our Services
                <span className="hero-cta-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="16" height="16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                    <path d="M8 5l7 7-7 7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </Link>
            </div>
            <div className="hero-character">
              <HeroVisual />
            </div>
          </div>
        </div>
      </div>

      <div className="container2 hero-mobile">
        <div className="home-men-text">
          <small>APPIVOROUS</small>
          <span>Built for What's Next.</span>
          <p>We make technology feel inevitable.</p>
          <p>An insatiable drive to create and</p>
          <p>advance digital technology.</p>
          <Link className="hero-cta" to="/services">
            Explore Our Services
            <span className="hero-cta-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="16" height="16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <path d="M8 5l7 7-7 7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </Link>
        </div>
        <div className="mobile-man">
          <HeroVisual />
        </div>
      </div>
    </section>
  );
}

export default Hero;
